import { render } from "./NewHomeContent.vue?vue&type=template&id=b72ff85c&scoped=true"
const script = {}

import "./NewHomeContent.vue?vue&type=style&index=0&id=b72ff85c&scoped=true&lang=scss"

import exportComponent from "/Users/gisselareyes/Documents/Github/gisse-la/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72ff85c"]])

export default __exports__